import { defineMessage } from "react-intl";

export const userMessages = {
  createTitle: defineMessage({
    id: "atmosms.users.create.title",
    description: "User administration: create title",
    defaultMessage: "Create user",
  }),
  createDescription: defineMessage({
    id: "atmosms.users.create.description",
    description: "User administration: create description",
    defaultMessage:
      "Enter the full name and password. A Latin username and a Bitrix messenger contact will be created automatically.",
  }),
  fullName: defineMessage({
    id: "atmosms.users.full_name",
    description: "User administration: full name",
    defaultMessage: "Full name",
  }),
  nameHelp: defineMessage({
    id: "atmosms.users.name_help",
    description: "User administration: name help",
    defaultMessage:
      "Up to 50 characters. This name is shown in Matrix and Bitrix.",
  }),
  username: defineMessage({
    id: "atmosms.users.username",
    description: "User administration: username",
    defaultMessage: "Username",
  }),
  usernameHelp: defineMessage({
    id: "atmosms.users.username_help",
    description: "User administration: username help",
    defaultMessage:
      "Generated from the full name. If occupied, a number will be added. The username stays unchanged when the name is edited.",
  }),
  password: defineMessage({
    id: "atmosms.users.password",
    description: "User administration: password",
    defaultMessage: "Password",
  }),
  confirmPassword: defineMessage({
    id: "atmosms.users.confirm_password",
    description: "User administration: confirm password",
    defaultMessage: "Repeat password",
  }),
  passwordHelp: defineMessage({
    id: "atmosms.users.password_help",
    description: "User administration: password help",
    defaultMessage: "At least 8 characters. MAS also checks password strength.",
  }),
  passwordMismatch: defineMessage({
    id: "atmosms.users.password_mismatch",
    description: "User administration: password mismatch",
    defaultMessage: "The passwords do not match.",
  }),
  save: defineMessage({
    id: "atmosms.users.save",
    description: "User administration: save",
    defaultMessage: "Save",
  }),
  cancel: defineMessage({
    id: "atmosms.users.cancel",
    description: "User administration: cancel",
    defaultMessage: "Cancel",
  }),
  accountCreated: defineMessage({
    id: "atmosms.users.account_created",
    description: "User administration: account created",
    defaultMessage:
      "The account already exists. Continue this operation to finish setup without creating another account.",
  }),
  bitrixPending: defineMessage({
    id: "atmosms.users.bitrix_pending",
    description: "User administration: bitrix pending",
    defaultMessage:
      "Matrix is ready. Adding the Bitrix contact is queued and will be retried automatically.",
  }),
  details: defineMessage({
    id: "atmosms.users.details",
    description: "User administration: details",
    defaultMessage: "Open user details",
  }),
  editTitle: defineMessage({
    id: "atmosms.users.edit.title",
    description: "User administration: edit title",
    defaultMessage: "Edit full name",
  }),
  editDescription: defineMessage({
    id: "atmosms.users.edit.description",
    description: "User administration: edit description",
    defaultMessage:
      "The display name will be updated in Matrix and on the linked Bitrix contact.",
  }),
  employeeNotice: defineMessage({
    id: "atmosms.users.employee_notice",
    description: "User administration: employee notice",
    defaultMessage:
      "This account belongs to a Bitrix employee. A later employee synchronization can update the name from Bitrix.",
  }),
  editAction: defineMessage({
    id: "atmosms.users.edit_action",
    description: "User administration: edit action",
    defaultMessage: "Edit full name",
  }),
  success: defineMessage({
    id: "atmosms.users.success",
    description: "User administration: success",
    defaultMessage: "User created in Matrix and added to Bitrix.",
  }),
  editSuccess: defineMessage({
    id: "atmosms.users.edit_success",
    description: "User administration: edit success",
    defaultMessage: "Full name saved.",
  }),
  retry: defineMessage({
    id: "atmosms.users.retry",
    description: "User administration: retry",
    defaultMessage: "Retry",
  }),
  errorTitle: defineMessage({
    id: "atmosms.users.error_title",
    description: "User administration: error title",
    defaultMessage: "Could not finish setup",
  }),
};
